import { useState } from 'react';

import { Monitor, X } from 'lucide-react';

const DISMISS_KEY = 'wakeLockBanner:dismissed';

export function WakeLockBanner() {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === 'true');

  if (dismissed) {
    return null;
  }

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, 'true');
    setDismissed(true);
  };

  return (
    <div
      className="flex items-center justify-between rounded-lg border border-amber-200 bg-amber-50 px-4 py-2.5 text-sm text-amber-800"
      role="alert"
    >
      <div className="flex items-center gap-2">
        <Monitor className="h-4 w-4 shrink-0" />
        <p className="font-medium">
          Your browser doesn&apos;t support automatic screen lock prevention. To avoid interruptions
          during sessions, increase your screen timeout in your device settings.
        </p>
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        className="ml-3 shrink-0 rounded-md p-1 opacity-60 transition-opacity hover:opacity-100"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
